import {CompanyConfig} from '../types';
import {baseRoles, mergeWithDefaults} from './base.config';

const {labels, features, roles, layoutConfig} = mergeWithDefaults(
  {
    order: 'Order',
    orders: 'Orders',
    customer: 'Customer',
    customers: 'Customers',
    dispatch: 'Dispatch',
    payment: 'Money In',
  },
  {
    hasOrderTypeOnOrderDetails: true,
    hasLinkedOrderOnOrderDetails: true,
    hasPurchaseOrderOnOrderDetails: true,
    hasMoneyInOnOrderDetails: true,
    hasMoneyOutOnOrderDetails: true,
    hasShopifyIntegration: true,
    hasClientRoleFilterOnCustomers: true,
    hasJobDescriptionOnOrderDetails: true,
    hasCostAndProfitOnOrderDetails: true,
    hasOrderTypeOnTransactionDetails: true,
    hasOrderTypeSelectOnOrderCreation: true,
  },
  baseRoles,
  {
    orderDetailsSequence: [
      //
      3,
      //
      1,
      //
      2,
      //
      4,
    ],
    prescriptionsSequence: [
      //
      4,
      //
      5,
      //
      3,
      //
      2,
      //
      1,
    ],
    resellerContentSequence: [6, 5, 4, 3, 2, 1],
  }
);

export const pickupDropoffConfig: CompanyConfig = {
  type: 'pickup_dropoff',
  labels,
  features,
  roles,
  layoutConfig,
};
